export default __webpack_public_path__ + "static/media/word-icon.f41daf7f.svg";